import React, { useState } from 'react';
import SampleReportSection from '../components/SampleReportSection';
import aboutUsImage from '../assets/images/aboutus1.jpg';
import principleImage from '../assets/images/principle.png';
import { ChevronDown, ChevronUp } from 'lucide-react';

const teamMembers = [
  {
    name: "Rajesh Bipinchandra",
    role: "Our Mentor",
    shortBio: "Rajesh is a full-time proprietary stock trader and investor in the stock market. With almost three decades of experience...",
    fullBio: "Rajesh is a full-time proprietary stock trader and investor in the stock market. With almost three decades of experience, Rajesh has a deep passion for financial analysis and long-term investment strategies. His extensive experience in the market has allowed him to develop a nuanced understanding of risk, value investing, and portfolio management. Rajesh is also deeply committed to helping other researchers design and conduct studies that combine both qualitative and quantitative research methods. He always emphasizes the importance of balancing rigorous methodology with practical applications, ensuring that the research produced is both credible and relevant. Additionally, Rajesh is instrumental in building and maintaining a high-performing team, which has led to increased customer satisfaction and loyalty over the years."
  },
  {
    name: "Sahil J Solanki",
    role: "Executive Director & Research Analyst",
    shortBio: "Sahil is a dynamic professional with a solid educational foundation in management studies and a specialized certification as a research analyst...",
    fullBio: "Sahil is a dynamic professional with a solid educational foundation in management studies and a specialized certification as a research analyst. His academic and professional credentials equip him with a strong understanding of business management, financial analysis, and market research. Sahil holds a Research Analyst certification, which showcases his expertise in conducting thorough research and analysis in the financial markets. This enables him to make informed investment decisions and provide valuable insights to clients and stakeholders. Overall, Sahil is a result-driven director with a strong academic foundation, relevant certifications, and extensive professional experience. He is well positioned to drive strategic initiatives, deliver sustainable growth, and create long-term value for stakeholders."
  },
  {
    name: "Krupa J Shah",
    role: "Non-Executive Director",
    shortBio: "Krupa is a distinguished law graduate from the University of Mumbai. Her legal expertise and academic credentials have provided her with a solid foundation...",
    fullBio: "Krupa is a distinguished law graduate from the University of Mumbai. Her legal expertise and academic credentials have provided her with a solid foundation in various legal disciplines, including corporate law, commercial law, and regulatory compliance. Krupa has gained valuable experience through her academic pursuits and practical engagements in the legal field. Her work has involved advising on complex legal matters, providing strategic legal counsel, and ensuring that organizations operate within the bounds of the law. Krupa is committed to upholding the highest standards of legal integrity and corporate governance. Her leadership is characterized by a meticulous approach to legal compliance, a strategic mindset in handling challenges, and a dedication to fostering a culture of ethical business practices."
  },
  {
    name: "Alpa R Sanghrajka",
    role: "Non-Executive Director",
    shortBio: "Alpa is accomplished professional with an MCom degree. Her advanced education in commerce provides her with a comprehensive understanding of financial...",
    fullBio: "Alpa is accomplished professional with an MCom degree. Her advanced education in commerce provides her with a comprehensive understanding of financial management, business operations, and economic principles. Alpa is committed to promoting financial stability and strategic growth within the organization. Her leadership style is characterized by analytical rigor, a focus on sustainable financial practices, and a collaborative approach to achieving organizational goals. She is dedicated to fostering a culture of transparency and accountability in financial management, ensuring that decisions are always in the best interests of both the company and its stakeholders."
  },
  {
    name: "Jimit P Shah",
    role: "Head of Research",
    shortBio: "Jimit P Shah is a fundamental research analyst with over 20 years of experience in the financial services industry...",
    fullBio: "Jimit P Shah is a fundamental research analyst with over 20 years of experience in the financial services industry. He specializes in conducting in-depth analysis of companies and markets to assess their intrinsic value and investment potential. Jimit has helped institutional investors, private equity firms, and individual investors make informed decisions based on sound fundamental research. His areas of expertise include analyzing financial statements, forecasting earnings, evaluating market trends, and identifying undervalued investment opportunities. Jimit is passionate about empowering investors by providing them with deep, data-driven analysis to help them make sound investment decisions."
  },
  {
    name: "Hasti R Sanghrajka",
    role: "Chief Risk Officer",
    shortBio: "As FRM chartered professional with nearly 3 years of experience in risk advisory, Hasti possesses a strong foundation in risk management...",
    fullBio: "As FRM chartered professional with nearly 3 years of experience in risk advisory, Hasti possesses a strong foundation in risk management and financial analysis. She has worked with clients across diverse sectors, including financial institutions, real estate, manufacturing, healthcare, and government agencies. Hasti is skilled in assessing risks, implementing strategies to mitigate them, and ensuring that clients remain compliant with industry standards and regulations. With her FRM qualification, she is well-equipped to navigate the complexities of financial market risk, adapt to new challenges, and deliver high-quality, customized solutions that align with client objectives and industry standards."
  },
  {
    name: "Jain Aditya",
    role: "Financial Taxation Officer",
    shortBio: "Aditya is a Chartered Accountant with more than 10 years of experience in mergers & acquisitions...",
    fullBio: "Aditya is a Chartered Accountant with more than 10 years of experience in mergers and acquisitions. He has worked with a leading consulting firm in India, where his expertise spans across structuring advisory and providing hands-on implementation support for transactions such as acquisitions, divestitures, mergers, group restructuring, and succession planning. With a deep understanding of complex financial landscapes, Aditya helps businesses navigate their strategic goals and achieve successful outcomes in transformative deals. His approach is always strategic, leveraging his financial acumen to drive value creation in every deal."
  },
  {
    name: "Arpit Wadia",
    role: "Algorithm Developer & Data Analyst",
    shortBio: "Arpit Wadia is a professional algorithm developer with over 6 years of experience...",
    fullBio: "Arpit Wadia is a professional algorithm developer with over 6 years of experience in designing sophisticated algorithms for the trading industry. He has worked with major brokerage firms in India and specializes in creating complex solutions for both proprietary firms and individual traders. Arpit leverages his deep understanding of the trading landscape to develop cutting-edge, efficient, and reliable algorithms that optimize trading strategies and drive success. His work is focused on enhancing the performance of trading systems, ensuring that they are robust, scalable, and able to meet the dynamic demands of the financial markets."
  },
  {
    name: "Anjali Bansal",
    role: "Associate Member",
    shortBio: "Anjali Bansal is an Associate Member of the Institute of Company Secretaries of India...",
    fullBio: "Anjali Bansal is an Associate Member of the Institute of Company Secretaries of India, Master in Business Policy and Corporate Governance, a Law Graduate, and a Graduate in Commerce (Accountancy Hons) with an experience of over 9 years. She is highly experienced in formation of companies/ LLP's/ OPCs and other Corporate Law matters, conducting of corporate and legal due diligence for primary and secondary investments, requisite e filings with the MCA, RBI/FEMA compliances, SEBI compliances under Investment Advisers, Research Analyst, AIF and PMS Regulations."
  }
];

const TeamMemberCard = ({ member }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-[#0f1a2e] p-6 rounded-lg border border-gray-700">
      <h3 className="text-xl font-bold text-yellow-400 mb-1">{member.name}</h3>
      <p className="text-white font-medium mb-3">{member.role}</p>
      <p className="text-gray-400 text-sm leading-relaxed mb-4">
        {isExpanded ? member.fullBio : member.shortBio}
      </p>
      <button 
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center gap-2 text-yellow-400 hover:text-yellow-300 transition-colors text-sm font-medium"
      >
        {isExpanded ? (
          <>
            <span>See less</span>
            <ChevronUp className="w-4 h-4" />
          </>
        ) : (
          <>
            <span>See more</span>
            <ChevronDown className="w-4 h-4" />
          </>
        )}
      </button>
    </div>
  );
};

const AboutUs = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-white py-16">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            {/* Left Content */}
            <div>
              <h1 className="text-5xl font-bold mb-8 text-gray-900">
                ABOUT THE COMPANY
              </h1>
              <p className="text-gray-600 mb-6 leading-relaxed">
                At CLIMB CAPITAL, our mission is to empower clients with the tools and resources necessary for 
                informed financial decision-making. Committed to excellence and customer satisfaction, we provide 
                tailored solutions that align with your unique goals and aspirations. Let us support you in your 
                journey toward financial success. Whether you aim to invest, save, or grow your wealth, our expert 
                advisors are here to guide you through the complexities of the financial landscape and help you 
                achieve your objectives
              </p>
              <p className="text-gray-600 mb-10 leading-relaxed">
                Climb Capital provides stock ideas as a focused service, delivering curated investment opportunities 
                to empower your decision-making. Our goal is to equip you with valuable insights while you maintain 
                full control over your investment choices.
              </p>

              {/* Our Mission */}
              <div className="mb-8">
                <h2 className="text-lg font-semibold text-blue-600 underline underline-offset-4 mb-3">Our Mission</h2>
                <p className="text-gray-600 leading-relaxed">
                  To deliver transformative financial solutions uniquely designed for each client's goals. 
                  Through expert insights and unwavering support, we empower our clients to conquer 
                  financial complexities and achieve their wealth aspirations.
                </p>
              </div>

              {/* Our Vision */}
              <div className="mb-8">
                <h2 className="text-lg font-semibold text-blue-600 underline underline-offset-4 mb-3">Our Vision</h2>
                <p className="text-gray-600 leading-relaxed">
                  To ignite financial confidence by equipping clients with the knowledge and tools to make 
                  bold, informed decisions, guiding them toward enduring success and robust financial 
                  security.
                </p>
              </div>
            </div>

            {/* Right Image */}
            <div className="flex justify-center lg:justify-end">
              <img
                src={aboutUsImage}
                alt="About Climb Capital"
                className="w-full max-w-md h-auto rounded-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-16 bg-[#1b2d4a]">
        <div className="container mx-auto px-6">
          {/* Header */}
          <h2 className="text-4xl font-bold mb-4 text-white">
            Meet Our <span className="text-yellow-400">Directors & Team</span>
          </h2>
          <p className="text-yellow-400 font-medium mb-6">Our Leadership Team</p>
          
          {/* Stats */}
          <div className="flex items-center gap-4 mb-12">
            <span className="text-5xl font-bold text-yellow-400">9+</span>
            <p className="text-gray-300 text-sm max-w-md">
              Our experienced leadership team is committed to driving success and long-term growth.
            </p>
          </div>

          {/* Team Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {teamMembers.map((member, index) => (
              <TeamMemberCard key={index} member={member} />
            ))}
          </div>
        </div>
      </section>

      {/* Guiding Principles Section */}
      <section className="py-16 bg-gray-100">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
            {/* Left - Image */}
            <div>
              <img 
                src={principleImage} 
                alt="Guiding Principles" 
                className="w-full rounded-lg shadow-lg"
              />
            </div>
            
            {/* Right - Principles */}
            <div>
              <h2 className="text-4xl font-bold mb-8 text-gray-900">
                Our Guiding Principles
              </h2>
              <div className="space-y-4">
                <div className="bg-white p-5 rounded-lg shadow-md">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Accessibility</h3>
                  <p className="text-gray-600 text-sm">
                    We believe everyone should have access to high-quality financial guidance.
                  </p>
                </div>
                <div className="bg-white p-5 rounded-lg shadow-md">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Transparency</h3>
                  <p className="text-gray-600 text-sm">
                    Clear, honest, and open communication with our clients at every step.
                  </p>
                </div>
                <div className="bg-white p-5 rounded-lg shadow-md">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Client-Centric</h3>
                  <p className="text-gray-600 text-sm">
                    Your financial goals and needs are at the heart of everything we do.
                  </p>
                </div>
                <div className="bg-white p-5 rounded-lg shadow-md">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Innovative</h3>
                  <p className="text-gray-600 text-sm">
                    Embracing technology and modern strategies to deliver better results.
                  </p>
                </div>
                <div className="bg-white p-5 rounded-lg shadow-md">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Expert Guidance</h3>
                  <p className="text-gray-600 text-sm">
                    Our team of seasoned professionals provides knowledgeable and trustworthy advice.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sample Report Section */}
      <SampleReportSection />
    </div>
  );
};

export default AboutUs;
